(function () {
  'use strict';

  class Footer {
    constructor() {
      if (!window.Shopify || !window.Shopify.designMode) return;
      this.init();
    }

    setupTitle() {
      const title = this.DOM.footerTitle;
      if (!title) return;

      const updateCharCount = () => {
        const text = title.textContent.trim();
        title.style.setProperty('--char-count', text.length);
      };

      updateCharCount();

      this.titleObserver = new MutationObserver(updateCharCount);
      this.titleObserver.observe(title, { childList: true, characterData: true, subtree: true });
    }

    resize() {
      if (this.DOM && this.DOM.footerTitle && this.DOM.footerTitle.dataset.largeTitle) {
        this.setupTitle();
      }
    }

    setup() {
      if (this.DOM && this.DOM.footerTitle && this.DOM.footerTitle.dataset.largeTitle) {
        this.setupTitle();
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    destroy() {
      if (this.titleObserver) {
        this.titleObserver.disconnect();
        this.titleObserver = undefined;
      }
      this.DOM = undefined;
    }

    init() {
      const footer = document.querySelector('.js-footer');

      if (footer) {
        this.DOM = {
          footer: footer,
          footerTitle: footer.querySelector('.js-footer-title')
        };
        this.setup();
      }
    }
  }

  window.Universe.Footer = Footer;
})();
